import React from "react";
import { dataTypes } from "../../dataTypes";
import "../../../css/utility.scss";

const Selector = React.memo(
  ({ dataType, role, onHandleChangeDatatype, disabled, isNewAddedByPreOrPro }) => {
    return (
      <select
        className="w-100"
        value={dataType ? dataType : ""}
        onChange={onHandleChangeDatatype}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        disabled={isNewAddedByPreOrPro ? false : role !== "preProcessor" || disabled}
      >
        <option value="">
          <em>Datatype</em>
        </option>
        {dataTypes.map((item, index) => {
          return (
            <option value={item?.value} key={item?.value}>
              {item.type}
            </option>
          );
        })}
      </select>
    );
  }
);

const DataTypeSelector = ({
  parameterData,
  onHandleChangeDatatype,
  parameterIndex,
  role,
  isDataRejectedByProcessor,
  entireBatchRejectedByPro,
}) => {
  const isDisable = () => {
    let isDisable = false;
    if (!entireBatchRejectedByPro) {
      if (isDataRejectedByProcessor) {
        let isAnyCellRejected = parameterData?.mappings?.some(
          (ele) => ele?.processorCellRejection?.isRejected
        );

        isDisable =
          isAnyCellRejected || parameterData?.processorRowRejection?.isRejected
            ? false
            : true;
      }
    }

    return isDisable;
  };

  return (
    <Selector
      dataType={parameterData?.dataType}
      isNewAddedByPreOrPro={
        role === "preProcessor"
          ? parameterData?.isNewAddedByPre
          : parameterData?.isNewAddedByPro
      }
      onHandleChangeDatatype={(e) =>
        onHandleChangeDatatype(
          e.target.value,
          parameterData?.parameter,
          parameterIndex
        )
      }
      parameter={parameterData?.parameterData}
      role={role}
      parameterIndex={parameterIndex}
      disabled={isDisable()}
    />
  );
};

export default DataTypeSelector;
